import {
  Alert,
  Avatar,
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "../redux/reducer/rootReducer";
import { DealerDashboard } from "../compenents/Dashboard/DealerDashboard";
import { CustomerDashboard } from "../compenents/Dashboard/CustomerDashboard";
import { AdminDashboard } from "../compenents/Dashboard/AdminDashboard";

export const Home = (props: any) => {
  const { setupId, userType } = useSelector(
    (state: AppState) => state.authReducer
  );
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 4,
        pt: 0,
      }}
    >
      <Container maxWidth={false}>
        {!(setupId && setupId !== "") && userType == "User" ? (
          <Grid container pb={2}>
            <Grid item xs={12}>
              <Alert severity="error">
                Setup not exist!, make sure you initialize the Shopify Setup (
                <Link to={"/dmsSetup"}>Click here</Link>)
              </Alert>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        {userType === "User" ? (
          <DealerDashboard></DealerDashboard>
        ) : userType === "Customer" || userType === "PortalCustomer" ? (
          <CustomerDashboard></CustomerDashboard>
        ) : (
          <AdminDashboard></AdminDashboard>
        )}
      </Container>
    </Box>
  );
};
